import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SectionLabel, GoldButton } from "@/components/ui-kit";
import { PageHero, FinalCTA } from "@/components/blocks";
import { images } from "@/data/site";

const steps = [
  { n: "01", title: "Valutazione iniziale", text: "Analizziamo il tuo livello di partenza, le tue esigenze e i tuoi obiettivi." },
  { n: "02", title: "Programmazione personalizzata", text: "Costruiamo un programma su misura, calibrato sui risultati da raggiungere." },
  { n: "03", title: "Allenamento individuale", text: "Ogni sessione è seguita da un professionista dedicato, passo dopo passo." },
  { n: "04", title: "Pacchetti personal training", text: "Formule flessibili pensate per adattarsi ai tuoi ritmi e alla tua costanza." },
  { n: "05", title: "Monitoraggio dei progressi", text: "Aggiorniamo il percorso nel tempo, in base ai tuoi miglioramenti." },
];

export default function PersonalTraining() {
  return (
    <>
      <Seo title="Personal Training a Lusciano | Body Evolution 2.0" description="Personal Training su misura a Lusciano: valutazione iniziale, programmazione personalizzata e monitoraggio dei progressi con Body Evolution 2.0." />
      <PageHero label="Personal Training" title="Personal Training su misura" image={images.personalTraining}
        text="Il servizio di Personal Training di Body Evolution 2.0 è dedicato a chi desidera un percorso individuale, seguito da un professionista e costruito su obiettivi concreti. Ogni allenamento viene programmato in base al livello di partenza, alle esigenze personali e ai risultati da raggiungere." />

      <section className="bg-ink text-ivory grain py-24 lg:py-32 relative">
        <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-10">
          <Reveal><SectionLabel dark>Come funziona</SectionLabel></Reveal>
          <Reveal delay={0.1}><h2 className="mt-6 font-display font-medium tracking-tight text-3xl lg:text-5xl max-w-2xl">Un metodo chiaro, dedicato a te</h2></Reveal>
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={(i % 3) * 0.08}>
                <div className="lift bg-ink p-8 lg:p-10 h-full hover:bg-surface">
                  <span className="text-stroke font-display text-5xl font-extrabold">{s.n}</span>
                  <h3 className="mt-5 font-display text-xl font-medium text-gold">{s.title}</h3>
                  <p className="mt-3 text-ivory/60 text-sm leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <p className="mt-14 text-ivory/70 max-w-3xl leading-relaxed text-lg">
              Il personal training è ideale per chi vuole dimagrire, tonificare, aumentare la massa muscolare,
              migliorare la postura, riprendere ad allenarsi dopo un periodo di stop o lavorare su obiettivi
              specifici con maggiore attenzione.
            </p>
          </Reveal>
          <Reveal delay={0.3}><div className="mt-10"><GoldButton to="/contatti">Richiedi una consulenza</GoldButton></div></Reveal>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
